import { RESET_LAST_ITEM } from 'cart/constants/actionTypes';

export const resetLastItem = () => ({ type: RESET_LAST_ITEM });
